import { Navigate, useLocation } from 'react-router-dom';
import useAuth from 'hooks/useAuth';

// ==============================|| PROTECTED ROUTE ||============================== //
const ProtectedRoute = ({ children, adminOnly = false }) => {
  const { isAuthenticated, user } = useAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    // Redirect to login, preserve intended path
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (adminOnly && user?.role !== 'admin') {
    // Redirect non-admins to user-safe page (e.g., bookings)
    return <Navigate to="/bookings" state={{ from: location }} replace />;
  }

  return children;
};

export default ProtectedRoute;